export const useHelpers = () => {
    
    const getCurrentDate = () => {
      const today = new Date(); // Crea un objeto de fecha con la fecha actual
      const year = today.getFullYear(); // Obtiene el año
      const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
      const day = today.getDate(); // Obtiene el día del mes
  
      // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
      return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const getCurrentYear = () => {
      const today = new Date(); // Crea un objeto de fecha con la fecha actual
      const year = today.getFullYear(); // Obtiene el año
  
      // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
      return year;
    }
    
    const convertirNumeroALetras = (numero) => {
      const unidades = [
        "", "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE"
      ];
      const decenas = [
        "", "DIEZ", "VEINTE", "TREINTA", "CUARENTA", "CINCUENTA",
        "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"
      ];
      const especiales = [
        "DIEZ", "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", 
        "DIECISÉIS", "DIECISIETE", "DIECIOCHO", "DIECINUEVE"
      ];
      const centenas = [
        "", "CIENTO", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS",
        "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"
      ];
    
      if (numero === 100) return "CIEN";
      if (numero < 10) return unidades[numero];
      if (numero < 20) return especiales[numero - 10]; // Corregido: usar especiales para 10-19
      if (numero < 30) return numero === 20 ? "VEINTE" : "VEINTI" + unidades[numero - 20];
      if (numero < 100) {
        const dec = Math.floor(numero / 10);
        const uni = numero % 10;
        return `${decenas[dec]}${uni > 0 ? " Y " + unidades[uni] : ""}`;
      }
      if (numero < 1000) {
        const cen = Math.floor(numero / 100);
        const resto = numero % 100;
        return `${centenas[cen]}${resto > 0 ? " " + convertirNumeroALetras(resto) : ""}`;
      }
      return "";
    };

    const convertirCantidadALetras = (cantidad) => {

      const convertirMiles = (numero) => {
        if (numero < 1000) return convertirNumeroALetras(numero);
        const miles = Math.floor(numero / 1000);
        const resto = numero % 1000;
    
        // Manejo especial para "UN MIL"
        const milesTexto = miles === 1 ? "UN" : convertirNumeroALetras(miles);
        return `${milesTexto} MIL${resto > 0 ? " " + convertirNumeroALetras(resto) : ""}`;
      };
    
      // Quitar comas y convertir a número
      const cantidadNumerica = parseInt(cantidad.replace(/,/g, ""), 10);
    
      // Convertir la cantidad y agregar sufijo
      const texto = convertirMiles(cantidadNumerica);
      return `${texto} QUETZALES EXACTOS`;
    };
    
    const convertirFechaALetras = (fecha) => {

      const meses = [
        "", "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
      ];
  
      const [anio, mes, dia] = fecha.split("-");
      const diaTexto = convertirNumeroALetras(parseInt(dia));
      const mesTexto = meses[parseInt(mes)];
      const anioTexto = `${convertirNumeroALetras(Math.floor(anio / 1000))} MIL ${convertirNumeroALetras(anio % 1000)}`;
  
      // return `${diaTexto} DE ${mesTexto} DEL AÑO ${anioTexto}`;
      return `${diaTexto} días del mes de ${mesTexto} del año ${anioTexto}`;
    };
    
   
    return Object.freeze({
        getCurrentDate,
        getCurrentYear,
        convertirCantidadALetras,
        convertirFechaALetras
    })
}